import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value"]

import { useDebounceFn } from '@vueuse/core'
import {
  convertToNumericValue,
  passNumericInputValidation,
  stripNonDigits
} from './../utils/input'
import { KeydownEvent, PasteEvent } from './../types'


export default /*#__PURE__*/_defineComponent({
  __name: 'NumericInput',
  props: {
  modelValue: {
    type: [String, Number],
    default: ''
  },

  maxDecimals: {
    type: Number,
    default: 6
  }
},
  emits: ["update:modelValue"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', state: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const debounceSanitizeDecimalPlace = useDebounceFn((value: string) => {
  const formattedValue = convertToNumericValue(
    value,
    props.maxDecimals
  ).toString()

  emit('update:modelValue', formattedValue)
}, 500)

function onWheel(event: WheelEvent) {
  event.preventDefault()
}

function onKeyDown(payload: KeyboardEvent) {
  const event = payload as KeydownEvent<HTMLInputElement>

  if (
    !passNumericInputValidation(event, props.maxDecimals === 0 ? ['.'] : [])
  ) {
    event.preventDefault()
  }
}

function onPaste(payload: ClipboardEvent) {
  const event = payload as PasteEvent<HTMLInputElement>
  const { clipboardData } = event

  event.preventDefault()

  if (clipboardData) {
    const value = clipboardData.getData('text')
    const digitOnlyValue = stripNonDigits(value).toString()
    const formattedValue = convertToNumericValue(
      digitOnlyValue,
      props.maxDecimals
    )

    emit('update:modelValue', `${formattedValue}`)
  }
}

function onChange(event: any) {
  const { value } = event.target

  emit('update:modelValue', value)
  debounceSanitizeDecimalPlace(value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", _mergeProps({
    class: "input-base",
    type: "number"
  }, _ctx.$attrs, {
    value: __props.modelValue,
    onInput: onChange,
    onPaste: onPaste,
    onKeydown: onKeyDown,
    onWheel: onWheel
  }), null, 16, _hoisted_1))
}
}

})